import { Component, EventEmitter, OnInit, Output, ViewChild, Injector, signal, ChangeDetectionStrategy } from '@angular/core';
import { PaymentSummaryDisplayModel, PaymentSummaryModel,CustomerAccountModel,OrderTransactionModel } from 'src/app/models/payment-summary.model';
import { GetPaymentTokenService } from 'src/app/adapters/getPaymentToken.service';
import { GetInsuranceRenewMotorService } from 'src/app/adapters/getInsuranceRenewMotor.service';
import { environment } from 'src/environments/environment';
import { CreateCustomerAccountService } from 'src/app/adapters/createCustomerAccount.service';
import { CreateOrderTransactiontService } from 'src/app/adapters/createOrderTransaction.service';
import { formatDate } from '@angular/common';
import { GenVoucherNumberService } from 'src/app/adapters/genVoucherNumber.service';
import { TiscoModalComponent } from 'src/app/shared/component/tisco-modal/tisco-modal.component';
import { CreatePaymentDetailService } from 'src/app/adapters/createPaymentDetail.service';
import { BuyInsuranceService } from 'src/app/adapters/buyInsurance.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { StoreDataService } from '../services/store-data.service';
import { ConstantsService } from '../../shared/service/constants/constants.service';
import { BaseComponents } from '../../base.component';
import { GetMaskingService } from './../../adapters/getMasking.service';
import { default as theme } from './../renewal-theme.json';
import liff from '@line/liff';
declare var window: any;

@Component({
  selector: 'app-payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrls: ['./payment-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone:false
})
export class PaymentSummaryComponent extends BaseComponents implements OnInit {
  @ViewChild(TiscoModalComponent) modal;
  loading = signal<boolean>(false);

  logger_text = ""
  display = signal<PaymentSummaryDisplayModel>({});
  model: PaymentSummaryModel = {};
  renewMotorUCID = '';
  renewMotorLetterUCID = '';
  product_type: number;
  isMotor = signal<boolean>(false);
  liffId: string;
  profile: any;
  channelId: string;
  paymentMethod: string;
  amount: string;
  electronic_channel: any;
  comcode: string;
  ref3: string;

  style: any = {};
  // access_token_line : string = ""
  liff_channel_id : string = "";
  channel_line_id : string = "";
  constructor(
    protected injectorObj: Injector,
    private getPaymentTokenService: GetPaymentTokenService,
    private getInsuranceRenewMotorService: GetInsuranceRenewMotorService,
    private createCustomerAccountService: CreateCustomerAccountService,
    private createOrderTransactiontService: CreateOrderTransactiontService,
    private genVoucherNumberService: GenVoucherNumberService,
    private createPaymentDetailService: CreatePaymentDetailService,
    private buyInsuranceService: BuyInsuranceService,
    private route: ActivatedRoute,
    private router: Router,
    private storeDataService: StoreDataService,
    private ConstantsService: ConstantsService,
    private getMaskingService: GetMaskingService
  ) {
    super(injectorObj);
   }
  async ngOnInit() {
    
    this.logger.info('payment-summary Init');
    if (environment.log_level == 'debug') {
      window.vConsole = new window.VConsole();
    }
    this.logger.info(['payment-summary','window:', window.location.href]);
    this.oninitParamRouter();
    try {
      if (this.isMotor()) {
          this.logger_text = "Credit card Motor:"
          this.logger.info([this.logger_text, this.renewMotorUCID, "letter ucid", this.renewMotorLetterUCID]);
          this.getInsuranceRenewMotor();
        } else {
          this.logger_text = "Credit card Non-Motor:"
          this.logger.info([this.logger_text, this.renewMotorUCID]);
          this.getInsuranceNonRenewMotor();
        }
      // await liff.init({ liffId: this.liffId })
      // if(liff.isLoggedIn() === false && liff.isInClient() === false){
      //   this.logger.info([this.logger_text,'payment-summary login liff callback path:', window.location.href]);
      //   liff.login({ redirectUri: window.location.href })
      // }else{
      //   this.access_token_line = await liff.getAccessToken();
      //   this.logger.debug([this.logger_text,'payment-summary access_token_line:', this.access_token_line]);        
      //   this.logger.info(['payment-summary get line success']);      
      //   if (this.isMotor) {
      //     this.logger_text = "Credit card Motor:"
      //     this.logger.info([this.logger_text, this.renewMotorUCID, "letter ucid", this.renewMotorLetterUCID]);
      //     this.getInsuranceRenewMotor();
      //   } else {
      //     this.logger_text = "Credit card Non-Motor:"
      //     this.logger.info([this.logger_text, this.renewMotorUCID]);
      //     this.getInsuranceNonRenewMotor();
      //   }     
      // }
    }
    catch (error) {
      console.log("catch"); 
      this.logger.info(['error catch getProfile', error.message]);
      if (error.code === '401' || error?.message === "The access token expired" || error?.message === "Load failed" || error?.message === "access_token is required") {
        this.logger.error([this.logger_text,'error line_token qr-barcode :', error?.message]);
        liff.logout()
        liff.login({ redirectUri: window.location.href })
        } else {
          this.logger.error(`${this.logger_text} error qr-barcode ${error?.message}`);
          this.router.navigate(['/renewal/page-error']);
        }
    };
  }

  oninitParamRouter() {    
  
    this.renewMotorUCID = this.route.snapshot.queryParamMap['params'].dataucid || '';
    this.renewMotorLetterUCID = this.route.snapshot.queryParamMap['params'].letterucid || '';
    this.product_type = this.route.snapshot.queryParamMap['params'].product_type || '';
    this.liffId = this.route.snapshot.queryParamMap['params'].appRef || '';
    this.paymentMethod = this.route.snapshot.queryParamMap['params'].payment_method || '';
    this.channelId = this.route.snapshot.queryParamMap['params'].rm_channelId || '';
    this.amount = this.route.snapshot.queryParamMap['params'].amount || '';
    this.comcode = this.route.snapshot.queryParamMap['params'].comcode || '';
    this.channel_line_id = this.route.snapshot.queryParamMap['params'].channel_line_id || '';
    this.liff_channel_id = this.route.snapshot.queryParamMap['params'].liff_channel_id || '';
    this.style = theme[this.comcode];
    // 
    this.model.product_type = this.product_type;
    this.model.liffId = this.liffId;
    this.model.channelId = this.channelId;
    this.model.amount = this.amount;
    this.model.paymentMethod = this.paymentMethod;
    this.model.subchannel = this.route.snapshot.queryParamMap['params'].subchannel ? parseInt(this.route.snapshot.queryParamMap['params'].subchannel) : null;

    // 
    this.logger.info(['renewMotorUCID:', this.renewMotorUCID]);
    this.logger.info(['renewMotorLetterUCID:', this.renewMotorLetterUCID]);
    this.logger.info(['product_type:', this.product_type]);    
    if (this.product_type == this.ConstantsService.MOTOR) {
      this.isMotor.set(true)
    }
    if (this.renewMotorUCID === '' || this.renewMotorLetterUCID === '' || this.product_type === null) {
      this.logger.info('payment-summary not have params');
      this.modal.show({
        title: 'Header Information',
        callBack: 'home',
        body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
      });
    }
  }

  initialDisplay(result_1_2936, result_1_2937, result_1_2277, result_1_2279, result_1_1401) {
    let ref1 = '0';
    if (this.isMotor()) {
      ref1 = result_1_2936._6258 ? result_1_2936._6258 : '0';
      this.display.update( res => ({
        ...res,
        insuredType : result_1_2279._13142 ? result_1_2279._13142 : '',
        insurer : result_1_2277._13116 ? result_1_2277._13116 : ''
      }))
    } else {
      // TODO: NON MOTOR AMOUNT
      ref1 = result_1_2936._6258 ? result_1_2936._6258 : '0';
      this.display.update(res => ({
        ...res,
        insuredType : result_1_2279 ? result_1_2279._3104 : '',
        insurer : result_1_2277._13116 ? result_1_2277._13116 : '',
      }))
    }

    this.display.update(obj => ({
      ...obj,
    titleTH :'รายละเอียดการชำระเงิน',
    logo : this.style.Logo,
    merchantName : result_1_1401._1291,
    ref1 : ref1,
    insuredTypeLabel : 'ผลิตภัณฑ์',
    insurerLabel : 'ประกันโดย',
    nameLabel : 'ชื่อผู้เอาประกัน',
    name : result_1_2936._1291 + ' ' + result_1_2936._1292,
    amountLabel : 'ยอดชำระ',
    amount : parseFloat(this.amount),
    amountBahtLabel : 'บาท',
    checkoutBtnLabel : 'ดำเนินการชำระเงิน',
    }));

    // SET THE MODEL
    this.model.ref1 = ref1;
    // this.model.amount = amount
    // 
  }

  getInsuranceRenewMotor() {
    this.loading.set(true);
    this.getInsuranceRenewMotorService.exec({ renewMotorUCID: this.renewMotorUCID, renewMotorLetterUCID: this.renewMotorLetterUCID, isMotor: true }).then(async (res) => {      
      this.logger.info(['motor','response motor All']);
      // this.logger.info(['motor','getInsuranceRenewMotorService response:',this.marking(res)]);
      if (res['status'] === true) {
        this.logger.info(["Credit card Motor:", this.renewMotorUCID, "get renew data"]);
        this.model.renewMotorUCID = this.renewMotorUCID;
        this.model.renewMotorLetterUCID = this.renewMotorLetterUCID;
        const result_1_2936 = res['result_1_2936'].data[0];
        const result_1_2937 = res['result_1_2937'].data[0];
        let showlogRenewMotor = {
          ...result_1_2936,
          _1291 : this.getMaskingService.maskingData(result_1_2936._1291),
          _1292 : this.getMaskingService.maskingData(result_1_2936._1292),
          _13 : this.getMaskingService.maskingData(result_1_2936._13),
          _16218 : this.getMaskingService.maskingData(result_1_2936._16218),
          _16219 : this.getMaskingService.maskingData(result_1_2936._16219),
          _25 : this.getMaskingService.maskingData(result_1_2936._25),
        }
        const result_1_9 = res['result_1_9'].data[0];
        const result_1_424 = res['result_1_1424'].data[0];
        const result_1_2277 = res['result_1_2277'].data[0];
        const result_1_2279 = res['result_1_2279'].data[0];
        const result_1_1401 = res['result_1_1401'].data[0];
        this.ref3 = `${result_1_2936._12201}-${result_1_2936._16055}`;
        this.logger.info(["Credit card Motor:", this.renewMotorUCID, "Ref3", this.ref3]);
        // this.logger.info(["Payment-summary: Ref3 =", this.ref3]);
        this.initialDisplay(result_1_2936, result_1_2937, result_1_2277, result_1_2279, result_1_1401);
        this.logger.info(["Credit card Motor:", this.renewMotorUCID, "create customer account start"]);
        let bodyCustomerAccount : CustomerAccountModel = this.populateBodyCustomerAccount(result_1_2936, result_1_2937, result_1_9,"motor");        
        let showlogbodyCustomerAccount : CustomerAccountModel = {
          referenceID : bodyCustomerAccount.referenceID,
          registrationNumber : this.getMaskingService.maskingData(bodyCustomerAccount.registrationNumber),
          email : bodyCustomerAccount.email,
          fistName : this.getMaskingService.maskingData(bodyCustomerAccount.fistName),
          lastName : this.getMaskingService.maskingData(bodyCustomerAccount.lastName),
          mobile : this.getMaskingService.maskingData(bodyCustomerAccount.mobile),
          maritalStatus : bodyCustomerAccount.maritalStatus,
          genderCode : bodyCustomerAccount.genderCode,
          titleCode : bodyCustomerAccount.titleCode,
          dateOfBirth : this.getMaskingService.maskingData(bodyCustomerAccount.dateOfBirth),
          otherRegistrationNumber : this.getMaskingService.maskingData(bodyCustomerAccount.otherRegistrationNumber),
          renewMotor : bodyCustomerAccount.renewMotor,
          typeofRenew : bodyCustomerAccount.typeofRenew
        };
        this.logger.info(['Credit card Motor:',this.renewMotorUCID,'bodyCustomerAccount', showlogbodyCustomerAccount]);
        // console.log('bodyCustomerAccount', bodyCustomerAccount);
        let responseCustomerAccount = await this.createCustomerAccount(bodyCustomerAccount);
        // console.log('responseCustomerAccount', responseCustomerAccount);
        this.logger.info(["Credit card Motor:", this.renewMotorUCID, "create customer account res", responseCustomerAccount]);
        if (responseCustomerAccount.status) {
          responseCustomerAccount = responseCustomerAccount.data;
          // SET THE MODEL
          this.model.accountIdentityUCID = responseCustomerAccount.accountIdentityUCID;
          this.model.identityUCID = responseCustomerAccount.identityUCID;
          this.model.productInfoUCID = responseCustomerAccount.productUCID;
          // 
          this.logger.info(["Credit card Motor:", this.renewMotorUCID, "get voucher number"]);
          const voucherNumber = await this.getVoucherId();
          // console.log('voucherNumber', voucherNumber);
          this.logger.info(["Credit card Motor:", this.renewMotorUCID, "get voucher number res", voucherNumber]);
          const bodyOrderTransaction : OrderTransactionModel = this.populateBodyOrderTransaction(responseCustomerAccount, result_1_2936, result_1_424, voucherNumber);
          this.logger.info(["Credit card Motor:", this.renewMotorUCID, "create Order transaction"]);
          // let showlogBodyOrderTransaction : OrderTransactionModel = bodyOrderTransaction;
          // showlogBodyOrderTransaction.amount = 0;
          // this.logger.info(['payment-summary','Credit card Motor:',this.renewMotorUCID, "bodyOrderTransaction",bodyOrderTransaction]);
          const responseOrderTransaction = await this.createOrderTransaction(bodyOrderTransaction);
          this.logger.info([this.logger_text, this.renewMotorUCID, "create Order transaction res", responseOrderTransaction]);
          this.logger.info([this.logger_text, this.renewMotorUCID, "chcek Order transaction status"]);
          // console.log('responseOrderTransaction', responseOrderTransaction);
          await this.checkStatusOrderTransaction(responseOrderTransaction, responseCustomerAccount, result_1_424, voucherNumber);
        }
        else {
          this.logger.info(["Credit card Motor:", this.renewMotorUCID, "create customer account is false"]);
          this.loading.set(false);
          this.modal.show({
            title: 'Header Information',
            callBack: 'home',
            body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
          });
        }

      }
      else {        
        this.logger.info(["Credit card Motor:", this.renewMotorUCID, "getInsuranceRenewMotorService is false"]);
        this.loading.set(false);
        this.modal.show({
          title: 'Header Information',
          callBack: 'home',
          body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
        });
      }
    }).catch((e) => {
      this.loading.set(false);
      this.logger.error(`error getInsuranceRenewMotor: ${e.message}`);
      this.modal.show({
        title: 'Header Information',
        callBack: 'home',
        body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
      });
    });
  }

  getInsuranceNonRenewMotor() {
  
    this.logger.info("Non-motor start");
    this.loading.set(true);
    this.getInsuranceRenewMotorService.exec({ renewMotorUCID: this.renewMotorUCID, renewMotorLetterUCID: this.renewMotorLetterUCID, isMotor: false }).then(async (res) => {
      this.logger.info(['nonmotor','response nonmotor All']);      
      // this.logger.info(['nonmotor','res getInsuranceRenewNonMotor', this.marking(res)]);
      if (res['status'] === true) {
        this.logger.info(["Credit card Non-Motor:", this.renewMotorUCID, "get non-motor detail"]);
        this.model.renewMotorUCID = this.renewMotorUCID;
        this.model.renewMotorLetterUCID = this.renewMotorLetterUCID;
        const result_1_2953 = res['result_1_2953'].data[0];        
        const result_1_2954 = res['result_1_2954'].data[0];
        // this.logger.info(['Credit card Non-Motor:',this.renewMotorUCID,'result1_2953',result_1_2953]);
        // this.logger.info(['Credit card Non-Motor:',this.renewMotorUCID,'result1_2954',result_1_2954]);
        const result_1_9 = res['result_1_9'].data[0];
        const result_1_424 = res['result_1_1424'].data[0];
        const result_1_2277 = res['result_1_2277'].data[0];
        const result_1_2279 = res['result_1_2279'].data ? res['result_1_2279'].data[0] : null;
        const result_1_1401 = res['result_1_1401'].data[0];
        // this.initialDisplay(result_1_2936, result_1_2937, result_1_2277, result_1_2279, result_1_1401);
        this.model.ref1 = result_1_2953._6258 ? result_1_2953._6258 : '0';
        this.ref3 = `${result_1_2953._6229}-${result_1_2953._40}`;
        this.logger.info(["Credit card Non-Motor:", this.renewMotorUCID, "Ref3", this.ref3]);
        // this.logger.info(["Payment-summary: Ref3 =", this.ref3]);
        this.logger.info(["Credit card Non-Motor:", this.renewMotorUCID, "create customer account start"]);
        const bodyCustomerAccount : CustomerAccountModel = this.populateBodyCustomerAccount(result_1_2953, result_1_2954, result_1_9,"nonmotor");
        let showlogbodyCustomerAccount : CustomerAccountModel = {
          referenceID : bodyCustomerAccount.referenceID,
          registrationNumber : this.getMaskingService.maskingData(bodyCustomerAccount.registrationNumber),
          email : bodyCustomerAccount.email,
          fistName : this.getMaskingService.maskingData(bodyCustomerAccount.fistName),
          lastName : this.getMaskingService.maskingData(bodyCustomerAccount.lastName),
          mobile : this.getMaskingService.maskingData(bodyCustomerAccount.mobile),
          maritalStatus : bodyCustomerAccount.maritalStatus,
          genderCode : bodyCustomerAccount.genderCode,
          titleCode : bodyCustomerAccount.titleCode,
          dateOfBirth : this.getMaskingService.maskingData(bodyCustomerAccount.dateOfBirth),
          otherRegistrationNumber : this.getMaskingService.maskingData(bodyCustomerAccount.otherRegistrationNumber),
          renewMotor : bodyCustomerAccount.renewMotor,
          typeofRenew : bodyCustomerAccount.typeofRenew
        };        
        this.logger.info(["Credit card Non-Motor:", this.renewMotorUCID,'showlogbodyCustomerAccount:', showlogbodyCustomerAccount]);
        let responseCustomerAccount = await this.createCustomerAccount(bodyCustomerAccount);
        this.logger.info(["Credit card Non-Motor:", this.renewMotorUCID, "create customer account res", responseCustomerAccount]);
        // console.log('responseCustomerAccount', responseCustomerAccount);
        if (responseCustomerAccount.status) {
          responseCustomerAccount = responseCustomerAccount.data;
          // SET THE MODEL
          this.model.accountIdentityUCID = responseCustomerAccount.accountIdentityUCID;
          this.model.identityUCID = responseCustomerAccount.identityUCID;
          this.model.productInfoUCID = responseCustomerAccount.productUCID;
          // 
          this.logger.info(["Credit card Non-Motor:", this.renewMotorUCID, "get voucher id"]);
          const voucherNumber = await this.getVoucherId();
          // console.log('voucherNumber', voucherNumber);
          this.logger.info(["Credit card Non-Motor:", this.renewMotorUCID, "get voucher id res:", voucherNumber]);
          this.logger.info(["Credit card Non-Motor:", this.renewMotorUCID, "create order transaction"]);
          const bodyOrderTransaction : OrderTransactionModel = this.populateBodyOrderTransaction(responseCustomerAccount, result_1_2953, result_1_424, voucherNumber);
          let showlogBodyOrderTransaction : OrderTransactionModel = {
            "securityID" : bodyOrderTransaction.securityID,
            "identityUCID" : bodyOrderTransaction.identityUCID,
            "accountIdentityUCID" : bodyOrderTransaction.accountIdentityUCID,
            "sellerOrReceiverUCID" : bodyOrderTransaction.sellerOrReceiverUCID,
            "orderNumber" : bodyOrderTransaction.orderNumber,
            "productInfoUCID" : bodyOrderTransaction.productInfoUCID,
            "refNo1" : bodyOrderTransaction.refNo1,
            "refNo2" : bodyOrderTransaction.refNo2,
            "currency" : bodyOrderTransaction.currency,            
            "voucherNumber" : bodyOrderTransaction.voucherNumber,
            "renewMotor" : bodyOrderTransaction.renewMotor,
            "renewMotorUCID" : bodyOrderTransaction.renewMotorUCID,
            "orderStatus" : bodyOrderTransaction.orderStatus,
            "isNonmotor" : bodyOrderTransaction.isNonmotor,
          };          
          this.logger.info(['Credit card Non-Motor:',this.renewMotorUCID, "bodyOrderTransaction",showlogBodyOrderTransaction]);
          // console.log('bodyOrderTransaction', bodyOrderTransaction);
          const responseOrderTransaction = await this.createOrderTransaction(bodyOrderTransaction);
          // console.log('responseOrderTransaction', responseOrderTransaction);
          this.logger.info(['Credit card Non-Motor:', this.renewMotorUCID, "create order transaction res", responseOrderTransaction]);
          await this.checkStatusOrderTransaction(responseOrderTransaction, responseCustomerAccount, result_1_424, voucherNumber);
          this.logger.info(['Credit card Non-Motor:', this.renewMotorUCID, "Redirect to payment"]);
          this.runPayment();
        }
        else {
          this.logger.info(['Credit card Non-Motor: create customer account is false']);
          this.loading.set(false);
          this.modal.show({
            title: 'Header Information',
            callBack: 'home',
            body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
          });
        }

      }
      else {
        this.logger.info(['Credit card Non-Motor: getInsuranceRenewNonMotor is false']);
        this.loading.set(false);
        this.modal.show({
          title: 'Header Information',
          callBack: 'home',
          body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
        });
      }
    }).catch((e) => {
      this.loading.set(false);
      this.logger.error(`error getInsuranceRenewMotor: ${e.message}`);
      this.modal.show({
        title: 'Header Information',
        callBack: 'home',
        body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
      });
    });

  }

  checkStatusOrderTransaction = async (responseOrderTransaction, responseCustomerAccount, result_1_424, voucherNumber) => {
    if (responseOrderTransaction.status) {
      responseOrderTransaction = responseOrderTransaction.data;
      // SET THE MODEL
      this.model.orderTransactionUCID = responseOrderTransaction.orderTransactionUCID;
      this.model.voucherNumber = responseOrderTransaction.voucherNumber;
      this.logger.info([this.logger_text, this.renewMotorUCID, "create payment detail"]);
      const bodyPaymentDetail = this.populatePaymentDetail(responseCustomerAccount, result_1_424, voucherNumber, responseOrderTransaction);
      let showlogbodyPaymentDetail = {
        'identityUCID':bodyPaymentDetail.identityUCID,
        'productInfoUCID':bodyPaymentDetail.productInfoUCID,
        'accountIdentityUCID':bodyPaymentDetail.accountIdentityUCID,   
        'voucherNumber':bodyPaymentDetail.voucherNumber,
        'orderTransactionUCID':bodyPaymentDetail.orderTransactionUCID,
        'paymentMethod':bodyPaymentDetail.paymentMethod,
        'paymentChannel':bodyPaymentDetail.paymentChannel,
        'paymentProvider':bodyPaymentDetail.paymentProvider,        
        'paymentStatus':bodyPaymentDetail.paymentStatus,
        "renewMotor":bodyPaymentDetail.renewMotor
      };
      this.logger.info([this.logger_text, this.renewMotorUCID ,showlogbodyPaymentDetail]);
      const responsePaymentDetail = await this.createPaymentDetail(bodyPaymentDetail);
      this.logger.info([this.logger_text, this.renewMotorUCID, "create payment detail res", responsePaymentDetail]);
      // console.log('responsePaymentDetail', responsePaymentDetail);
      if (responsePaymentDetail.status === 'ErrorF' || responsePaymentDetail.status === 'Error') {
        this.logger.info([this.logger_text, this.renewMotorUCID, "create payment detail false"]);
        this.modal.show({
          title: 'Header Information',
          callBack: 'home',
          body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
        });
      } else {
        // SET THE MODEL
        this.logger.info([this.logger_text, this.renewMotorUCID, "sucess all flow"]);
        this.model.paymentDetailID = responsePaymentDetail.data.paymentDetailID;
      }

      // 
      this.loading.set(false);
    }
    else {
      this.logger.info([this.logger_text, this.renewMotorUCID, "responseOrderTransaction is false"]);
      this.loading.set(false);
      this.modal.show({
        title: 'Header Information',
        callBack: 'home',
        body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
      });
    }
  };

  packer(o) {
    const str = JSON.stringify(o);
    const mess = btoa(str);
    return mess.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, ',');
  }
  unpacker(str) {
    let mess = str.replace(/-/g, '+').replace(/_/g, '/').replace(/,/g, '=');
    mess = atob(mess);
    return JSON.parse(mess);
  }

  populateBodyOrderTransaction = (responseCustomerAccount, result_1_2936, result_1_424, voucherNumber) => {
    this.logger.info("create body OrderTransaction start");
    let last3rdAcc = null;

    if (this.isMotor()) {
      last3rdAcc = result_1_2936._16055.slice(result_1_2936._16055.length - 3);
    } else {
      last3rdAcc = result_1_2936._40.slice(result_1_2936._40.length - 3);
    }
    // const orderNumber = result_1_2936._6259 ? result_1_2936._6259 : new Date().getTime() + last3rdAcc;
    // const orderNumber = '1103232423432423';
    const ref2 = formatDate(new Date(), 'yyMMddHHmmss', 'en') + last3rdAcc;
    const orderNumber = result_1_2936._6259 ? result_1_2936._6259 : ref2;

    // SET THE MODEL
    this.model.orderNumber = orderNumber;
    // 
    const bodyOrderTransaction : OrderTransactionModel = {
      "securityID": "RENEW",
      "identityUCID": responseCustomerAccount.identityUCID,
      "accountIdentityUCID": responseCustomerAccount.accountIdentityUCID,
      "sellerOrReceiverUCID": responseCustomerAccount.identityUCID,
      "orderNumber": orderNumber,
      "productInfoUCID": result_1_424._3108,
      "refNo1": result_1_2936._6258 ? result_1_2936._6258 : '0',
      "refNo2": orderNumber,
      "currency": 138, //fix 138= baht
      "amount": Number(this.amount),
      "voucherNumber": voucherNumber['reference'],
      "renewMotor": true,
      "renewMotorUCID": this.renewMotorUCID,
      "orderStatus": 4,
      "isNonmotor": !this.isMotor()
    };

    return bodyOrderTransaction;
  };

  getVoucherId(): Promise<any> {
    return this.genVoucherNumberService.exec({}).then((res => {
      if (res['reference']) {
        return { status: true, reference: res['reference'] };
      }
      return { status: false };
    })).catch(e => {
      this.logger.error("error getContractReasonService: ", e);
      return { status: false, data: e };
    });

  }

  populateBodyCustomerAccount = (result_1_2936, result_1_2937, result_1_9,typeofRenew) => {
    const bodyCustomerAccount : CustomerAccountModel = {
      'referenceID': result_1_2937._40,
      "registrationNumber": result_1_2936._13,
      "email": null,
      "fistName": result_1_2936._1291,
      "lastName": result_1_2936._1292,
      "mobile": null,
      "maritalStatus": '',
      "genderCode": '',
      "titleCode": result_1_9._8,
      "dateOfBirth": '',
      "otherRegistrationNumber": null,
      "renewMotor": true,
      "typeofRenew":typeofRenew
    };
    return bodyCustomerAccount;
  };

  populatePaymentDetail = (responseCustomerAccount, result_1_424, voucherNumber, responseOrderTransaction) => {
    const bodyPaymentDetail = {
      'identityUCID': responseCustomerAccount.identityUCID,
      'productInfoUCID': result_1_424._3108,
      'accountIdentityUCID': responseCustomerAccount.accountIdentityUCID,
      // 'voucherNumber': this.product_type == this.ConstantsService.MOTOR ? responseOrderTransaction.voucherNumber : voucherNumber.reference,
      'voucherNumber': responseOrderTransaction.voucherNumber,
      'orderTransactionUCID': responseOrderTransaction.orderTransactionUCID,
      'paymentMethod': 4,
      'paymentChannel': 5,
      'paymentProvider': 1,
      'paymentAmt': parseFloat(this.amount),
      'paymentStatus': 4,
      "renewMotor": true
    };
    return bodyPaymentDetail;
  };

  createCustomerAccount(bodyCustomerAccount): Promise<any> {
    return this.createCustomerAccountService.exec(bodyCustomerAccount, '').then((res: any) => {
      if (res.status && res.data.accountIdentityUCID != undefined) {
        return { status: true, data: res.data };
      } else {
        return { status: false, data: res };
      }
    }).catch((e) => {
      this.logger.error("error createCustomerAccount: ", e);
      return { status: false, data: e };
    });
  }

  createOrderTransaction(bodyOrderTransaction): Promise<any> {
    return this.createOrderTransactiontService.exec(bodyOrderTransaction, '').then((res: any) => {
      return { status: true, data: res };
    }).catch((e) => {
      this.logger.error("error createOrderTransaction: ", e);
      return { status: false, data: e };
    });
  }

  createPaymentDetail(bodyPaymentDetail): Promise<any> {
    return this.createPaymentDetailService.exec(bodyPaymentDetail, '').then((res) => {
      this.logger.info('createPaymentDetailService createMessageCode:', res['createMessageCode']);
      if (res['createMessageCode'] == '30000') {
        return { status: 'success', data: res };
      } else {
        return { status: 'Error' };
      }
    }).catch(() => {
      return { status: 'ErrorF' };
    });
  }

  async runPayment() {
    // console.log('runPayment')
    this.loading.set(true);
    // this.openModalWaiting.emit(true);
    const body = {};
    this.logger.info(['payment-summary runPayment start']);
    this.getPaymentTokenService.exec(body, "TIS2021072200010").then(async (res: any) => {
      this.logger.info(['runPayment','res::', res]);
      let showlogModel = {
        "product_type":this.model.product_type,
        "liffId":this.model.liffId,
        "channelId":this.model.channelId,        
        "paymentMethod":this.model.paymentMethod,
        // "lineId":this.model.lineId,
        "renewMotorUCID":this.model.renewMotorUCID,
        "renewMotorLetterUCID":this.model.renewMotorLetterUCID,
        "ref1":this.model.ref1,
        "accountIdentityUCID":this.model.accountIdentityUCID,
        "identityUCID":this.model.identityUCID,
        "productInfoUCID":this.model.productInfoUCID,
        "orderNumber":this.model.orderNumber,
        "orderTransactionUCID":this.model.orderTransactionUCID,
        "voucherNumber":this.model.voucherNumber,
        "paymentDetailID":this.model.paymentDetailID,
        "subchannel": this.model.subchannel
    }
      this.logger.info(['runPayment','this model:', showlogModel]);
      const bt = this.packer(this.model);
      this.logger.info(['runPayment','btoa:', bt]);
      // this.logger.info(['runPayment','atob:', this.unpacker(bt)]);

      // this.liffId = '1653923162-wJQEqrYj'
      const liff_url = `https://liff.line.me/${this.liffId}?page=payment-callback/${bt}`;
      this.logger.info(['runPayment','liff_url:', liff_url]);
      const data = {
        token: res.data.token,
        amount: this.isMotor() ? `${this.display().amount}` : `${parseFloat(this.amount)}`,
        merchant_id: environment.insure_merchant_id,
        ref_1: this.model.ref1,
        ref_2: this.model.orderNumber,
        ref_3: this.ref3,
        // return_uri: `${environment.my_host}/renewal/payment-callback/${bt}`,
        return_uri: liff_url,
        lang: 'th',
        description: this.product_type == this.ConstantsService.MOTOR ? this.display().insuredType : "ผลิตภัณฑ์ประกันภัย",
        enable_3d_secure: 'true'
      };
      let showlogData = {
        token: res.data.token,        
        merchant_id: environment.insure_merchant_id,
        ref_1: this.model.ref1,
        ref_2: this.model.orderNumber,
        ref_3: this.ref3,
        // return_uri: `${environment.my_host}/renewal/payment-callback/${bt}`,
        return_uri: liff_url,
        lang: 'th',
        description: this.product_type == this.ConstantsService.MOTOR ? this.display().insuredType : "ผลิตภัณฑ์ประกันภัย",
        enable_3d_secure: 'true'
      }      
      const url = environment.endpoint_payment_common_charge;
      this.logger.info(['runPayment url:',url]);
      this.logger.info(['runPayment','bodyData:',showlogData]);
      this.logger.info(['runPayment','environment.insure_merchant_id', environment.insure_merchant_id]);
      this.post(url, data);
      this.loading.set(false);
    }).catch((e) => {
      this.logger.error(['runPayment error',e.message]);
      this.loading.set(false);
      this.modal.show({
        title: 'Header Information',
        callBack: 'home',
        body: 'เนื่องจากขณะนี้มีผู้ใช้งานเป็นจำนวนมาก กรุณารอสักครู่และทำรายการใหม่อีกครั้ง แต่หากไม่สามารถทำรายการได้กรุณาติดต่อ ทิสโก้ อินชัวร์',
      });
    });
  }

  private post(path: string, params: { [x: string]: string; token?: any; amount?: any; merchant_id?: string; ref_1?: any; ref_2?: any; return_uri?: string; lang?: string; description?: any; enable_3d_secure?: string; hasOwnProperty?: any; }, method = 'post') {
    // The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    const form = document.createElement('form');
    form.method = method;
    form.action = path;

    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = params[key];

        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }
}




